import { retrieve } from "framework/http/endpoint";
import { createCollectionResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate } from "framework/http/transport";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var EventsApiUri = ApiUriPrefix + "officials";
function apiGetOfficials(page, pageSize) {
    if (page === void 0) { page = null; }
    if (pageSize === void 0) { pageSize = null; }
    var uri = "".concat(EventsApiUri);
    var queryParams = [];
    if (page !== null) {
        queryParams.push("page=".concat(page));
    }
    if (pageSize !== null) {
        queryParams.push("pageSize=".concat(pageSize));
    }
    if (queryParams.length > 0) {
        uri = uri + '?' + queryParams.join('&');
    }
    return retrieve(uri);
}
function apiGetOfficial(id) {
    return retrieve("".concat(EventsApiUri, "/").concat(id));
}
function apiGetOfficialRegistrations(idt) {
    var uri = "".concat(EventsApiUri, "/").concat(idt, "/registrations");
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportOfficialRegistration));
}
function fromTransportOfficialRegistration(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.date = fromApiTransportDate(entity.date);
    return result;
}
function apiGetOfficialCompetitionAttendance(idt) {
    var uri = "".concat(EventsApiUri, "/").concat(idt, "/competitions");
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportOfficialCompetitionAttendance));
}
function fromTransportOfficialCompetitionAttendance(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.date = fromApiTransportDate(entity.date);
    return result;
}
export { apiGetOfficials, apiGetOfficial, apiGetOfficialRegistrations, apiGetOfficialCompetitionAttendance };
